  <div fxFlex="60" fxFlexOffset.gt-sm="20" style="margin-top: 20px;"> 
    <table mat-table [dataSource]="missingLoginsUsers" style="max-height: 200px;">

        <ng-container matColumnDef="bga">
            <th mat-header-cell *matHeaderCellDef class="mat-col-small">
                BGA Nummer
            </th>
            <td mat-cell *matCellDef="let apotheke">
                {{ apotheke.bga }}
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name Kunde</th>
            <td mat-cell *matCellDef="let apotheke">
                {{ apotheke.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="strasse">
            <th mat-header-cell *matHeaderCellDef>
                Straße + Hausnummer
            </th>
            <td mat-cell *matCellDef="let apotheke">
                {{ apotheke.strasse }} {{ apotheke.hausnummer }}
            </td>
        </ng-container>

        <ng-container matColumnDef="plz">
            <th mat-header-cell *matHeaderCellDef class="mat-col-small">
                PLZ
            </th>
            <td mat-cell *matCellDef="let apotheke">
                {{ apotheke.plz }}
            </td>
        </ng-container>

        <ng-container matColumnDef="ort">
            <th mat-header-cell *matHeaderCellDef>Ort</th>
            <td mat-cell *matCellDef="let apotheke">
                {{ apotheke.ort }}
            </td>
        </ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            class="table-header-top"
        ></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
        ></tr>
    </table>
        <mat-paginator
            [pageSizeOptions]="[99999]"
            [length]="totalCount"
            [pageSize]="99999"
            [hidden]="true"
        ></mat-paginator>
  </div>